import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "col-12 col-xl-3 d-xl-block fullscreen collapse searchfilter float-left",
  id: "searchfilter"
}
const _hoisted_2 = { id: "searchfilter-wrapper" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "filter-box"
}
const _hoisted_6 = { class: "filter-box-headline" }
const _hoisted_7 = { class: "list-unstyled mb-0" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = ["value", "id"]
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "filter-box-count-number ml-auto" }
const _hoisted_13 = {
  key: 1,
  class: "filter-box"
}
const _hoisted_14 = { class: "filter-box-headline" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "filter-daterange-from" }
const _hoisted_17 = {
  class: "input-group",
  id: "filter-daterange-from-datepicker"
}
const _hoisted_18 = { for: "filter-daterange-to" }
const _hoisted_19 = {
  class: "input-group",
  id: "filter-daterange-to-datepicker"
}
const _hoisted_20 = {
  key: 2,
  class: "filter-box"
}
const _hoisted_21 = { class: "filter-box-headline" }
const _hoisted_22 = { class: "list-unstyled mb-0" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = ["data-target", "aria-controls"]
const _hoisted_25 = ["id"]
const _hoisted_26 = {
  key: 0,
  class: "list-unstyled mt-0"
}
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "form-check" }
const _hoisted_29 = ["value", "id"]
const _hoisted_30 = ["for"]
const _hoisted_31 = { class: "filter-box-count-number ml-auto" }
const _hoisted_32 = {
  key: 3,
  class: "filter-box"
}
const _hoisted_33 = { class: "filter-box-headline" }
const _hoisted_34 = { class: "list-unstyled mb-0" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = ["value", "id"]
const _hoisted_38 = ["for"]
const _hoisted_39 = { class: "filter-box-count-number ml-auto" }
const _hoisted_40 = {
  class: "col-12 content col-xl-9 content",
  id: "content",
  role: "main"
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "area-search" }
const _hoisted_45 = { class: "formContainer" }
const _hoisted_46 = { class: "input-group input-group-lg searchbar searchbar-container mb-3" }
const _hoisted_47 = {
  for: "area-search-query",
  class: "sr-only"
}
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "input-group-append" }
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "sr-only" }
const _hoisted_52 = {
  key: 0,
  id: "infoBlock",
  class: "infoBlock"
}
const _hoisted_53 = {
  key: 0,
  id: "infoBlockFound",
  class: "found searchresult-teaser text-center"
}
const _hoisted_54 = {
  key: 1,
  id: "infoBlockNotFound",
  class: "notFound searchresult-teaser text-center"
}
const _hoisted_55 = {
  key: 1,
  id: "infoBlock",
  class: "infoBlock"
}
const _hoisted_56 = {
  key: 0,
  id: "infoBlockFound",
  class: "found searchresult-teaser text-center"
}
const _hoisted_57 = {
  key: 1,
  id: "infoBlockNotFound",
  class: "notFound searchresult-teaser text-center"
}
const _hoisted_58 = {
  key: 2,
  class: "searchresult-teaser text-center"
}
const _hoisted_59 = { class: "d-xl-none d-print-none searchresult-teaser text-center" }
const _hoisted_60 = {
  href: "#searchfilter",
  class: "searchfilter-toggle",
  "data-toggle": "collapse",
  "aria-expanded": "false",
  "aria-controls": "searchfilter"
}
const _hoisted_61 = {
  key: 1,
  class: "searchresult-teaser text-center"
}
const _hoisted_62 = {
  key: 1,
  class: "row"
}
const _hoisted_63 = { class: "col-12 d-flex align-items-center justify-content-end flex-column flex-md-row" }
const _hoisted_64 = { class: "d-flex flex-column flex-sm-row" }
const _hoisted_65 = { class: "form-group mb-0 pl-3" }
const _hoisted_66 = {
  for: "sort",
  class: "sr-only"
}
const _hoisted_67 = { value: "date" }
const _hoisted_68 = { value: "relevance" }
const _hoisted_69 = { class: "" }
const _hoisted_70 = ["aria-pressed"]
const _hoisted_71 = ["aria-pressed"]
const _hoisted_72 = {
  key: 0,
  "aria-label": "Suchergebnis",
  class: "resultContainer search-results-container"
}
const _hoisted_73 = { class: "list row list-unstyled overview overview-list overview-searchresult has-pagination" }
const _hoisted_74 = {
  key: 0,
  class: "loadWrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Page = _resolveComponent("Page")!
  const _component_Asset = _resolveComponent("Asset")!
  const _component_Course = _resolveComponent("Course")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-right d-xl-none mt-3" }, [
          _createElementVNode("button", {
            class: "btn btn-link searchfilter-toggle collapsed",
            "data-toggle": "collapse",
            "data-target": "#searchfilter",
            "aria-expanded": "false"
          }, [
            _createElementVNode("span", {
              class: "icon icon-navigation_pfeil_schliessen_gross",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", { class: "sr-only" }, "Suchfilter ausblenden")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.t('vab.filter.title')), 1),
          _createElementVNode("button", {
            class: "btn btn-link btn-reset px-0",
            role: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
          }, _toDisplayString(_ctx.t('vab.filter.reset')), 1)
        ]),
        (_ctx.showTypeFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('vab.filter.system')), 1),
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemMap, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "mb-0",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                          value: value.id,
                          id: `filter-system-${value.id}`,
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                        }, null, 40, _hoisted_10), [
                          [_vModelCheckbox, _ctx.type]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `filter-system-${value.id}`
                        }, _toDisplayString(value.label), 9, _hoisted_11)
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getSystemCount(value)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDaterangeFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('vab.filter.daterange')), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t('vab.filter.daterangefrom')), 1),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    id: "filter-daterange-from",
                    placeholder: "TT.MM.JJJJ",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateFrom) = $event)),
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.dateFrom]
                  ])
                ]),
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t('vab.filter.daterangeto')), 1),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    id: "filter-daterange-to",
                    placeholder: "TT.MM.JJJJ",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateTo) = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.dateTo]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDepFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t('vab.filter.dep')), 1),
              _createElementVNode("ul", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depMap, ([key, value], index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "mb-0",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("button", {
                        class: "btn btn-link btn-reset text-body px-0 py-0 mt-1 mb-2 w-100 d-flex align-items-center",
                        type: "button",
                        "data-toggle": "collapse",
                        "data-target": `#filter-dep-outer-${index}`,
                        "aria-expanded": "false",
                        "aria-controls": `filter-dep-outer-${index}`
                      }, [
                        _createTextVNode(_toDisplayString(value.label) + " ", 1),
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "icon icon-navigation_pfeil_unten mt-n2 ml-auto px-0" }, null, -1))
                      ], 8, _hoisted_24)
                    ]),
                    _createElementVNode("div", {
                      class: "collapse",
                      id: `filter-dep-outer-${index}`
                    }, [
                      (value.deps && value.deps.length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.deps, (depInner, indexInner) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "mb-1",
                                key: depInner.id
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dep) = $event)),
                                      value: depInner.id,
                                      id: `filter-dep-inner-${index}-${indexInner}`,
                                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                                    }, null, 40, _hoisted_29), [
                                      [_vModelCheckbox, _ctx.dep]
                                    ]),
                                    _createElementVNode("label", {
                                      class: "form-check-label",
                                      for: `filter-dep-inner-${index}-${indexInner}`
                                    }, _toDisplayString(depInner.label), 9, _hoisted_30)
                                  ]),
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.getDepCount(depInner)), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_25)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFormFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.t('vab.filter.participation')), 1),
              _createElementVNode("ul", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formMap, ([key, value], index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "mb-0",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form) = $event)),
                          value: value.id,
                          id: `filter-participation-${index}`,
                          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                        }, null, 40, _hoisted_37), [
                          [_vModelCheckbox, _ctx.form]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `filter-participation-${index}`
                        }, _toDisplayString(value.label), 9, _hoisted_38)
                      ]),
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.getFormCount(value.id)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("main", _hoisted_40, [
      _createElementVNode("h1", null, [
        (_ctx.pageTitle)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "title",
              id: "labelformodal",
              innerHTML: _ctx.sanitizeHtml(_ctx.pageTitle)
            }, null, 8, _hoisted_41))
          : _createCommentVNode("", true),
        (_ctx.pageSubtitle)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "subtitle",
              innerHTML: _ctx.sanitizeHtml(_ctx.pageSubtitle)
            }, null, 8, _hoisted_42))
          : _createCommentVNode("", true)
      ]),
      (_ctx.pageDescription)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "abstract",
            innerHTML: _ctx.sanitizeHtml(_ctx.pageDescription)
          }, null, 8, _hoisted_43))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("form", {
            onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
            action: "#",
            method: "get"
          }, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t('search.headerViewSearchterm')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.queryString) = $event)),
                type: "search",
                id: "area-search-query",
                class: "search form-control",
                placeholder: _ctx.t('search.headerViewSearchterm')
              }, null, 8, _hoisted_48), [
                [_vModelText, _ctx.queryString]
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  class: "btn btn-brand1",
                  type: "submit",
                  id: "search-bottom-button",
                  title: _ctx.t('search.headerViewSearch2')
                }, [
                  _cache[20] || (_cache[20] = _createElementVNode("span", {
                    class: "icon icon-lupe",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.t('search.headerViewSearch2')), 1)
                ], 8, _hoisted_50)
              ])
            ])
          ], 32),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.result && _ctx.result.queryString)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      ((_ctx.result.numItems || 0) > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsAmountFound').replace('%TERM%', _ctx.result.queryString).replace('%AMOUNT%', (_ctx.result.numItems || 0).toString())), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsNotFound').replace('%TERM%', _ctx.result.queryString)), 1)
                          ]))
                    ]))
                  : (_ctx.result)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        ((_ctx.result.numItems || 0) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsAmountFoundNoQuerystring').replace('%AMOUNT%', (_ctx.result.numItems || 0).toString())), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsNotFoundNoQuerystring')), 1)
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.t('search.searchresultsEmptySearchString')), 1)
                      ])),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("a", _hoisted_60, _toDisplayString(_ctx.t('search.searchresultsOpenFilterString')), 1)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_61, " "))
        ])
      ]),
      (_ctx.result && (_ctx.result.numItems || 0) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchsortlabel')) + ":", 1),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.t('search.searchsortlabel')), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "custom-select",
                    name: "sort",
                    id: "sort",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sortType) = $event)),
                    onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onSubmitSort && _ctx.onSubmitSort(...args)))
                  }, [
                    _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.t('search.searchsortdate')), 1),
                    _createElementVNode("option", _hoisted_68, _toDisplayString(_ctx.t('search.searchsortrelevance')), 1)
                  ], 544), [
                    [_vModelSelect, _ctx.sortType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(`btn btn-link${_ctx.sortOrder == 'asc' ? '  text-primary' : ''}`),
                    "aria-pressed": _ctx.sortOrder == 'asc' ? 'true' : 'false',
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changeSortOrder('asc')))
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "icon icon-navigation_pfeil_zurueck mr-1 d-inline-block rotate-90" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('search.searchsortasc')), 1)
                  ], 10, _hoisted_70),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(`btn btn-link${_ctx.sortOrder == 'desc' ? '  text-primary' : ''}`),
                    "aria-pressed": _ctx.sortOrder == 'desc' ? 'true' : 'false',
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeSortOrder('desc')))
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "icon icon-navigation_pfeil_zurueck mr-1 d-inline-block rotate-n90" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.t('search.searchsortdesc')), 1)
                  ], 10, _hoisted_71)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_loading_container, { state: _ctx.state }, {
        default: _withCtx(() => [
          ((_ctx.result.numItems || 0) > 0)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_72, [
                _createElementVNode("ul", _hoisted_73, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.result && _ctx.result.result && _ctx.result.result.resultList || []), (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item['system_s'] === 'website')
                        ? (_openBlock(), _createBlock(_component_Page, {
                            key: 0,
                            item: item,
                            highlight: _ctx.getHighlight(item),
                            nodeLink: _ctx.getNodeLink(item),
                            ancestors: _ctx.getAncestors(item),
                            badges: _ctx.getBadges(item)
                          }, null, 8, ["item", "highlight", "nodeLink", "ancestors", "badges"]))
                        : _createCommentVNode("", true),
                      (item['system_s'] === 'dam')
                        ? (_openBlock(), _createBlock(_component_Asset, {
                            key: 1,
                            item: item,
                            highlight: _ctx.getHighlight(item),
                            nodeLink: _ctx.getNodeLink(item),
                            dependants: _ctx.getDependants(item),
                            badges: _ctx.getBadges(item)
                          }, null, 8, ["item", "highlight", "nodeLink", "dependants", "badges"]))
                        : _createCommentVNode("", true),
                      (item['system_s'] === 'courses')
                        ? (_openBlock(), _createBlock(_component_Course, {
                            key: 2,
                            item: item,
                            highlight: _ctx.getHighlight(item),
                            nodeLink: _ctx.getNodeLink(item),
                            ancestors: _ctx.getAncestors(item),
                            badges: _ctx.getBadges(item),
                            detailUrl: _ctx.detailUrl
                          }, null, 8, ["item", "highlight", "nodeLink", "ancestors", "badges", "detailUrl"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("div", {
                  class: "loader",
                  "aria-hidden": "true"
                }, null, -1)),
                (!_ctx.isLastPage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createVNode(_component_loading_container, { state: _ctx.pagingState }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "loadMore",
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.loadNext && _ctx.loadNext(...args)))
                          }, _toDisplayString(_ctx.t('search.searchresultsLoadmoreTitle')), 1)
                        ]),
                        _: 1
                      }, 8, ["state"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["state"])
    ])
  ], 64))
}